import React from 'react';
import { SideNavLink } from '@amzn/aac-chrome-internal-api';
import { LaunchFlag } from 'src/commons/components/LaunchFlag/LaunchFlag';

interface RenderFlagOptions {
  isMobile?: boolean;
  isInverted?: boolean;
}

// To be refactored to accept a Flag instead of the navItem after isNew and isBeta fields are deprecated
export const renderFlag = (
  navItem: SideNavLink,
  options?: RenderFlagOptions,
): React.ReactElement | null => {
  if (navItem.calloutTag) {
    return (
      <LaunchFlag
        flag={{
          type: navItem.calloutTag,
          label: navItem.calloutTag,
          ...options,
        }}
      />
    );
  }

  return null;
};
